import { Copy } from "lucide-react";
import { toast } from "sonner";
import { fmtAcc } from "@/lib/format";

export const AccountNo = ({ value, className = "", testid = "account-no", light = false }) => {
  if (!value) return null;
  const copy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      toast.success("Nomor rekening disalin");
    } catch {
      toast.error("Gagal menyalin");
    }
  };
  return (
    <span className={`inline-flex items-center gap-1.5 font-mono font-bold tracking-wider whitespace-nowrap ${className}`}>
      <span data-testid={testid}>{fmtAcc(value)}</span>
      <button type="button" onClick={copy} data-export-skip="1" data-testid={`${testid}-copy`} aria-label="Salin nomor rekening"
        className={`p-1 rounded-md transition-colors ${light ? "hover:bg-white/20" : "hover:bg-slate-200"}`}>
        <Copy className="h-3.5 w-3.5" />
      </button>
    </span>
  );
};
